import { Textarea } from '@chakra-ui/react'
import { JournalTextareaProps } from '../utils/types'

export const JournalTextarea = ({
  clinicalObservations,
  setClinicalObservations,
}: JournalTextareaProps) => {
  return (
    <Textarea
      value={clinicalObservations}
      onChange={(e) => setClinicalObservations(e.target.value)}
      height='sm'
    />
  )
}
